import { DimensionUnit, WeightUnit } from '@freight-cbm/shared-types';

export function convertToMeters(value: number, unit: DimensionUnit): number {
  if (value < 0) return NaN;
  switch (unit) {
    case DimensionUnit.Cm: return value / 100;
    case DimensionUnit.Mm: return value / 1000;
    case DimensionUnit.M: return value;
    case DimensionUnit.In: return value * 0.0254;
    case DimensionUnit.Ft: return value * 0.3048;
  }
}

export function convertToCm(value: number, unit: DimensionUnit): number {
  if (value < 0) return NaN;
  return convertToMeters(value, unit) * 100;
}

export function convertToInches(value: number, unit: DimensionUnit): number {
  if (value < 0) return NaN;
  return convertToMeters(value, unit) / 0.0254;
}

export function convertToKg(value: number, unit: WeightUnit): number {
  if (value < 0) return NaN;
  switch (unit) {
    case WeightUnit.Kg: return value;
    case WeightUnit.Lb: return value * 0.45359237;
  }
}

export function convertToLb(value: number, unit: WeightUnit): number {
  if (value < 0) return NaN;
  switch (unit) {
    case WeightUnit.Kg: return value / 0.45359237;
    case WeightUnit.Lb: return value;
  }
}

